// removed by extract-text-webpack-plugin
module.exports = {"notification":"Notification-module__notification___1kV9m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/Notification.module.sass
// module id = 1084
// module chunks = 0